import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NG_ENTITY_SERVICE_CONFIG } from '@datorama/akita-ng-entity-service';
import { AkitaNgRouterStoreModule } from '@datorama/akita-ng-router-store';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { PreviewAnyFile } from '@ionic-native/preview-any-file/ngx';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';

import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';
import { TranslocoConfig, TranslocoModule, TRANSLOCO_CONFIG } from '@ngneat/transloco';
import { LocaleFormatOptions, TranslocoDatePipe, TranslocoLocaleModule } from '@ngneat/transloco-locale';

import { environment } from '../environments/environment';
import { AboutModule } from './about/about.module';
import { AppMenuModule } from './app-menu/app-menu.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { TokenIncerceptor } from './auth/token-interceptor';
import { ImageModalPageModule } from './image-modal/image-modal.module';
import { translocoLoader } from './transloco.loader';
import { WebView } from '@awesome-cordova-plugins/ionic-webview/ngx';

export const globalFormatConfig: LocaleFormatOptions = {
  date: {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  },
};

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    AppRoutingModule,
    AuthModule,
    BrowserModule,
    HttpClientModule,
    ImageModalPageModule,
    AboutModule,
    AppMenuModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    TranslocoLocaleModule.init({
      localeConfig: {
        global: globalFormatConfig,
        localeBased: {
          'de-DE': globalFormatConfig,
          'en-US': globalFormatConfig,
        },
      },
    }),
    TranslocoModule,
    environment.production ? [] : AkitaNgDevtools.forRoot(),
    AkitaNgRouterStoreModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    PreviewAnyFile,
    Camera,
    StatusBar,
    SplashScreen,
    WebView,
    File,

    // AndroidPermissions,
    Network,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: TRANSLOCO_CONFIG,
      useValue: {
        availableLangs: ['en-US', 'de-DE'],
        defaultLang: 'de-DE',
        fallbackLang: 'en-US',
        // Disable excessive console warnings in dev mode.
        prodMode: true, //environment.production,
      } as TranslocoConfig,
    },
    TranslocoDatePipe,
    translocoLoader,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenIncerceptor,
      multi: true,
    },
    {
      provide: NG_ENTITY_SERVICE_CONFIG,
      useValue: {
        baseUrl: 'https://jsonplaceholder.typicode.com',
      },
    },
    //{ provide: ErrorHandler, useFactory: getErrorHandler },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
